import { PRODUCTS } from "@/data/products";

export default function EditorialMarquee() {
  const seq = (hidden) => (
    <span className="marquee-seq" key={hidden ? "b" : "a"} aria-hidden={hidden || undefined}>
      {PRODUCTS.map((p) => (
        <span className="marquee-item" key={p.id}>
          {p.name}
          <i className="marquee-cross">+</i>
        </span>
      ))}
    </span>
  );

  return (
    <div className="marquee" data-testid="editorial-marquee">
      <div className="marquee-track">
        {seq(false)}
        {seq(true)}
      </div>
    </div>
  );
}
